'use strict';

/**
 *
 * @name: nownessApp.bookmark
 *
 */

import AddToQueueDirective from './nn-add-to-queue.directive';
import LocalPlaylistFactory from './nn-local-playlist.factory';

const BookmarkModule = angular
  .module('nownessApp.bookmark', [])
  .directive('addToQueue', AddToQueueDirective)
  .factory('localPlaylist', LocalPlaylistFactory);

export default BookmarkModule.name;



// WEBPACK FOOTER //
// ./app/components/nn-bookmark/nn-bookmark.module.js